import type { InputDialogBaseButton } from '@egr/xbox/egr-gui-dialogs/utils/DialogUtils';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import * as React from 'react';

import { dialogManager } from '../stores/DialogManager';

import { DialogBar } from '@egr/xbox/egr-gui-dialogs/base/DialogBar';
import { DialogButton } from '@egr/xbox/egr-gui-dialogs/inputDialog/DialogButton';
import Dialog from '@egr/xbox/egr-gui-dialogs/utils/DialogOverride';

import { isString } from '@easterngraphics/wcf/modules/utils/string';

export const SimpleDialog = () => {
    const { simpleDialog } = dialogManager.useState(['simpleDialog']);

    if (simpleDialog == null) {
        return null;
    }

    function onCloseButton() {
        if (simpleDialog?.onClose != null) {
            simpleDialog.onClose();
        } else {
            dialogManager.closeDialog();
        }
    }

    function onClose(): void {
        if (simpleDialog?.onBackdropClick != null) {
            return simpleDialog.onBackdropClick();
        }
        onCloseButton?.();
    }

    function getSubTitle(value: React.ReactNode, index: number): React.ReactNode {
        if (isString(value)) {
            return <Typography key={index} variant="body2" display="block">{value}</Typography>;
        }
        return <React.Fragment key={index}>{value}</React.Fragment>;
    }

    function getButton(inputButton: InputDialogBaseButton, index: number): React.ReactNode {
        return (
            <DialogButton
                key={index}
                button={inputButton}
                close={onCloseButton}
            />
        );
    }

    const { title, subTitle, buttons } = simpleDialog;

    return (
        <Dialog
            fullScreen={simpleDialog.fullscreen}
            maxWidth="xs"
            open={true}
            onClose={onClose}
        >
            {simpleDialog.fullscreen ?
                <DialogBar close={onClose} label={title} bottomDivider /> :
                <DialogTitle>{title ? title : null}</DialogTitle>
            }
            {subTitle == null ? null : <DialogContent>{subTitle.map(getSubTitle)}</DialogContent>}
            {buttons == null ? null : <DialogActions>{buttons.map(getButton)}</DialogActions>}
        </Dialog>
    );
};

SimpleDialog.displayName = 'SimpleDialog';